/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseShopTheLookFragment, ShopTheLookFragment, FullShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look';

/**
 * Get a single ShopTheLook by ID (base - scalars only)
 */
export const getBaseShopTheLookById = gql`
  ${BaseShopTheLookFragment}

  query GetBaseShopTheLookById($id: String!, $locale: String!, $preview: Boolean) {
    shopTheLook(id: $id, locale: $locale, preview: $preview) {
      ...BaseShopTheLookFragment
    }
  }
`;

/**
 * Get a single ShopTheLook by ID (standard - 1 level deep)
 */
export const getShopTheLookById = gql`
  ${ShopTheLookFragment}

  query GetShopTheLookById($id: String!, $locale: String!, $preview: Boolean) {
    shopTheLook(id: $id, locale: $locale, preview: $preview) {
      ...ShopTheLookFragment
    }
  }
`;

/**
 * Get a single ShopTheLook by ID (full - 2 levels deep)
 */
export const getFullShopTheLookById = gql`
  ${FullShopTheLookFragment}

  query GetFullShopTheLookById($id: String!, $locale: String!, $preview: Boolean) {
    shopTheLook(id: $id, locale: $locale, preview: $preview) {
      ...FullShopTheLookFragment
    }
  }
`;

/**
 * Get all ShopTheLook entries with pagination (base - scalars only)
 */
export const getBaseShopTheLooks = gql`
  ${BaseShopTheLookFragment}

  query GetBaseShopTheLooks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShopTheLookOrder]
    $where: ShopTheLookFilter
    $preview: Boolean
  ) {
    shopTheLookCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseShopTheLookFragment
      }
    }
  }
`;

/**
 * Get all ShopTheLook entries with pagination (standard - 1 level deep)
 */
export const getShopTheLooks = gql`
  ${ShopTheLookFragment}

  query GetShopTheLooks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShopTheLookOrder]
    $where: ShopTheLookFilter
    $preview: Boolean
  ) {
    shopTheLookCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ShopTheLookFragment
      }
    }
  }
`;

/**
 * Get all ShopTheLook entries with pagination (full - 2 levels deep)
 */
export const getFullShopTheLooks = gql`
  ${FullShopTheLookFragment}

  query GetFullShopTheLooks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShopTheLookOrder]
    $where: ShopTheLookFilter
    $preview: Boolean
  ) {
    shopTheLookCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullShopTheLookFragment
      }
    }
  }
`;
